import React from 'react';
import "../Figure.css"


function Figure1() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
              <th> Concentration (mg/mL) </th>
              <th> Signal </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> 0 </td>
              <td> 1000 </td>
            </tr>
            <tr>
              <td> 40 </td>
              <td> 100 000 </td>
            </tr>
            <tr>
              <td> 95 </td>
              <td> 250 000 </td>
            </tr>
            <tr>
              <td> 180 </td>
              <td> 450 000 </td>
            </tr>
            <tr>
              <td> 330 </td>
              <td> 960 000 </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure1;